<div class="edp-container-error">
    <i class="icon icon-edponline-Bra-071 error-icon"></i>

    <div class="edp-container-error-item content-text">
        <h1>{{ "pt.edp.edponline.payment.agreement.error.title" | translate }}</h1>
        <p>{{ "pt.edp.edponline.payment.agreement.error.subtitle" | translate }}</p>
    </div>

    <div class="edp-container-error-item edp-container-error-item-btn-wrapper">
        <button type="button" class="btn btn-primary btn-close-size" (click)="close()">
            <span class="btn-text">{{ "pt.edp.edponline.payment.agreement.error.buttonclose" | translate }}</span>
        </button>
    </div>
</div>
